<div class="sub-title-class" *ngIf="spiderChartItemsData?.scenarioListForAnnumImpact.length > 0">
  <div *ngIf="!isISOReport" class="headingTitle" id="equivalencyUnits">
    <div>{{ reportResource.lblEquivalancyUnits }}</div>
  </div>
</div>
<div *ngIf="!isISOReport" class="tableHeading">
  <div class="uniqTableSeq">Table #1: {{ reportResource.lblEquivalancyUnits }}</div>
</div>
<div
  *ngIf="
    spiderChartItemsData?.isExport && spiderChartItemsData?.scenarioListForAnnumImpact.length > 0;
    else other_checked_isExport
  "
>
  <div class="row table-div">
    <div class="table-content">
      <table class="table">
        <thead>
          <tr>
            <td>{{ reportResource.lblCategory }}</td>
            <td>{{ reportResource.lblEquivalancyUnits }}</td>
            <td *ngFor="let item of spiderChartItemsData.scenarioListForAnnumImpact">
              {{ item?.scenarioname }}
            </td>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="
              let p of getRange(
                spiderChartItemsData?.scenarioListForAnnumImpact[0]?.indicators.split(';').length
              )
            "
          >
            <ng-container *ngIf="!isISOReport; else otherISO">
              <td>
                <span style="padding-right: 15px">{{ indicatornamelist[p] }}</span>
              </td>
            </ng-container>
            <ng-template #otherISO>
              <td>
                <div class="d-flex">
                  <!-- <div class="imageISO">
                    <img width="40" height="40" [src]='imagelistForCategory[p]' />
                  </div> <br /> -->
                  <div class="">
                    <span style="padding-right: 15px; display: block">{{
                      indicatornamelist[p]
                    }}</span>
                    <span class="verticalTableHeader" style="margin-top: 1px !important">{{
                      indicatorunitnamelist[p]
                    }}</span>
                  </div>
                </div>
              </td>
            </ng-template>
            <td>
              <img width="40" height="40" [src]="imagelist[p]" /><br />
              <span class="verticalTableHeader" style="margin-top: 1px !important">{{
                indicatorEquivalancyUnits[p]
              }}</span>
            </td>
            <td *ngFor="let item of tempArr">
              {{
                getMultiPlication(item[p] | decimalFormatPipe, multiplier[p]) | decimalFormatPipe
              }}
            </td>
          </tr>
        </tbody>
        <!-- <tbody *ngIf="!(spiderChartItemsData?.scenarioListForAnnumImpact.length > 0)">
          <tr>
            <td [attr.colspan]="spiderChartItemsData?.scenarioListForAnnumImpact.length + 2" class="lblNoData"> No
              record is available</td>
          </tr>
        </tbody> -->
      </table>
    </div>
  </div>
</div>

<ng-template #other_checked_isExport>
  <ng-container *ngIf="spiderChartItemsData?.scenarioListForAnnumImpact?.length > 0">
    <div class="row table-div">
      <div class="table-content">
        <table class="table">
          <thead>
            <tr>
              <td>{{ reportResource.lblCategory }}</td>
              <td>{{ reportResource.lblEquivalancyUnits }}</td>
              <td *ngFor="let item of spiderChartItemsData?.scenarioListForAnnumImpact">
                {{ item?.scenarioname }}
              </td>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let p of getRange(
                  spiderChartItemsData?.scenarioListForAnnumImpact[0]?.indicators?.split(';')
                    ?.length
                )
              "
            >
              <ng-container *ngIf="!isISOReport; else otherISO">
                <td>
                  <span style="padding-right: 15px">{{ indicatornamelist[p] }}</span>
                </td>
              </ng-container>
              <ng-template #otherISO>
                <td>
                  <div class="d-flex">
                    <!-- <div class="imageISO">
                      <img width="40" height="40" [src]='imagelistForCategory[p]' />
                    </div> <br /> -->
                    <div class="">
                      <span style="padding-right: 15px; display: block">{{
                        indicatornamelist[p]
                      }}</span>
                      <span class="verticalTableHeader" style="margin-top: 1px !important">{{
                        indicatorunitnamelist[p]
                      }}</span>
                    </div>
                  </div>
                </td>
              </ng-template>
              <td class="equivalencyUnitImage">
                <div
                  class="row"
                  [ngStyle]="{
                    'margin-left': isISOReport ? '0px' : null,
                    'align-items': isISOReport ? 'center' : null
                  }"
                >
                  <span
                    [ngClass]="{ verticalTableHeader: true, 'col-9': isISOReport }"
                    style="margin-top: 1px !important"
                    >{{ indicatorEquivalancyUnits[p] }}</span
                  >
                  <span [ngClass]="{ 'col-3': isISOReport }"
                    ><img width="40" height="40" [src]="imagelist[p]"
                  /></span>
                </div>
              </td>
              <td *ngFor="let item of tempArr">
                {{
                  getMultiPlication(item[p] | decimalFormatPipe, multiplier[p]) | decimalFormatPipe
                }}
              </td>
            </tr>
          </tbody>
          <!-- 
              <tbody *ngIf="!(spiderChartItemsData?.scenarioListForAnnumImpact.length > 0)">
                <tr>
                  <td [attr.colspan]="spiderChartItemsData?.scenarioListForAnnumImpact.length + 2" class="lblNoData"> No
                    record is available</td>
                </tr>
              </tbody> -->
        </table>
      </div>
    </div>
  </ng-container>
</ng-template>
